export default {"src":"/_next/static/media/hero.64974c01.svg","height":992,"width":992,"blurWidth":0,"blurHeight":0};